import linkWithCredentials from '../../utils/linkWithCredentials';
import { updatingCredentials } from '../../utils/downloadUpdatingCredentials';

export const replaceDocumentPage = async (axios, documentId, formValues, pageIndex) => {
  const params = `&page_index=${pageIndex}`;
  const url = `/documents/${documentId}`;
  const urlCred = linkWithCredentials(url);
  const urlCredWithParams = `${urlCred}${params}`;

  const formData = new FormData();
  formData.append('file', formValues.hiddenFileInput);

  await axios.request({
    url: urlCredWithParams, method: 'PUT', data: formData,
  }).then((response) => {
    const { headers } = response;
    updatingCredentials(headers);
  });
};
